// Auto Generated file, do not modify
import {
    apiDelete,
    apiGet,
    apiPost,
    apiPut,
    ApiRequestOptions,
} from "@redriver/cinnamon";
import { AuditCategory } from "mortar/Principal/Enums";
import { PagedView } from "mortar/Principal/Logic/Helpers";
import { AuditListView } from "mortar/Principal/Logic/Views";
import { makeAction, makeFormData } from "../lib";

export interface ListSheetAuditRouteParams {
    sheetId: string;
}

export interface ListSheetAuditQueryParams {
    search: string;
    pageSize: number;
    pageNumber: number;
    category: AuditCategory[];
}

export interface ListSheetAuditActionRequest {
    routeParams: ListSheetAuditRouteParams;
    queryParams: ListSheetAuditQueryParams;
    options?: Partial<
        ApiRequestOptions<PagedView<AuditListView>, "audits/listSheetAudit">
    >;
}

export const listSheetAudit = makeAction((
    { routeParams, queryParams, options }: ListSheetAuditActionRequest,
) => apiGet<PagedView<AuditListView>, "audits/listSheetAudit">(
    "audits/listSheetAudit",
    `sheets/${routeParams.sheetId}/audit-history`,
    queryParams,
    options,
), "audits/listSheetAudit");
